module.exports = __webpack_public_path__ + "img/delta.c4a52811.webp";